import React, { Dispatch, SetStateAction } from 'react';
import { Box } from '@mui/material';

import { CalendarView } from '../types';
import { CalendarViews } from './CalendarViews';
import { CalendarActions } from './CalendarActions';

interface Props {
  view: CalendarView;
  setView: Dispatch<SetStateAction<CalendarView>>;
}

export const CalendarPanel = ({ view, setView }: Props) => {
  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: '20% 1fr', gap: '1rem' }}>
      <CalendarViews view={view} setView={setView} />

      <CalendarActions />
    </Box>
  );
};
